<script setup>
import { ref, watch, computed } from 'vue';

import { 
  kPage, 
  kBlockTitle,
  kList,
  kListItem,
  kCheckbox,
} from 'konsta/vue';

import {useBooking} from '@/stores/booking'
const bookingStore = useBooking();

import StepNavigation from '@/components/StepNavigation.vue';

</script>


<template>

  <template v-for="service in bookingStore.services_with_team_selection">
    <k-block-title class="!block">Scegli l'operatore - <i>{{ service.name }}</i></k-block-title>
    <k-list strong outline>
      
      <k-list-item
        v-for="team_user in service.team_users"  
        label
        :title="team_user.frontend_name"
      >
        <template #media>
          <k-checkbox
            :name="'service_'+service.id"
            :value="team_user.id"
            :checked="bookingStore.services_team_users[service.id] == team_user.id"
            @change="e => {
              bookingStore.services_team_users[service.id] = parseInt(e.target.value)
              bookingStore.track(); 
            }"
          />

          <!-- <img
            class="rounded-full w-15 h-15 object-cover ml-2"
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSbKPKz5U_u5qvtcMzlqa_Z9Eb9m8PSBr7YGiksKhq7pK3sFERp9lE5GUCk6H8lY35wgt8&usqp=CAU"
            width="80"
            alt="demo"
          /> -->
        </template>
      </k-list-item>

    </k-list>
  </template>

  <StepNavigation/>

</template>